export const odluka_o_koristenju_godisnjeg_odmora = {
    templateId: 30,
    category: 3,
    templateTitle: 'Odluka o korištenju godišnjeg odmora',
    templateDescription: `<p>Poslodavac je dužan najmanje 15 dana prije početka korištenja godišnjeg odmora radnika obavijestiti ​o trajanju godišnjeg odmora i razdoblju njegova korištenja. Pri izračunu broja dana godišnjeg odmora na koji radnik ima pravo možete koristiti aplikaciju <a target="_blank" href="http://godisnji-odmor.com/">Godišnji Odmor</a>.</strong></p>`,
    description: `
    <h5><strong>OPIS DOKUMENTA</strong></h5>
    <p><strong>Odlukom o korištenju godišnjeg odmora radnik se obavještava ​o trajanju godišnjeg odmora i razdoblju njegova korištenja, pri čemu poslodavac mora o korištenju godišnjeg odmora obavijestiti radnika najmanje petnaest dana prije početka korištenja godišnjeg odmora.</strong></p>
    <p><strong>Pri izračunu broja dana godišnjeg odmora na koji radnik ima pravo možete koristiti aplikaciju <a target="_blank" href="http://godisnji-odmor.com/">Godišnji Odmor</a>.</strong></p>

    <p>Zakonom o radu propisano je najkraće trajanje godišnjeg odmora pa tako radnik ima za svaku kalendarsku godinu pravo na godišnji odmor od najmanje četiri tjedna, a maloljetnik i radnik koji radi na poslovima na kojima, uz primjenu mjera zaštite zdravlja i sigurnosti na radu, nije moguće zaštititi radnika od štetnih utjecaja u trajanju od najmanje pet tjedana.</p>
    <p>Kolektivnim ugovorom, sporazumom sklopljenim između radničkog vijeća i poslodavca, pravilnikom o radu ili ugovorom o radu može se utvrditi trajanje godišnjeg odmora duže od najkraćega propisanog Zakonom o radu.</p>
    <p>U praksi je uobičajeno da poslodavac odluka o korištenju godišnjeg odmora donosi na temelju molbe/zahtjeva radnika za korištenjem godišnjeg odmora, no važno je naglasiti da poslodavac može samostalno (i bez zahjeva radnika odnosno protivno zahtjevu radnika) odlučivati o korištenju godišnjeg odmora (odrediti samostalno radniku dane godišnjeg odmora), pridržavajući se zakonskih obveza.</p>
    <p>Ipak, jedan dan godišnjeg odmora radnik ima pravo koristiti kada on to želi, uz obvezu da o tome obavijesti poslodavca najmanje tri dana prije njegova korištenja, osim ako posebno opravdani razlozi na strani poslodavca to onemogućuju.</p>
    <p>Prije donošenja odluke o <strong>korištenju</strong> ​godišnjeg odmora potrebno je prethodno utvrditi ima li radnik pravo na tzv. <strong>puni godišnji odmor</strong> ​(najmanje četiri tjedna odnosno pet tjedana za maloljetnike) ili ima pravo na <strong>razmjerni godišnji odmor.</strong></p>
    <p>Radnik koji se prvi put zaposli ili koji ima prekid između dva radna odnosa duži od osam dana, stječe pravo na <strong>puni godišnji odmor</strong> nakon šest mjeseci neprekidnog radnog odnosa kod toga poslodavca.</p>
    <p>S druge strane, radnik koji se prvi put zaposli i nije radio neprekidno šest mjeseci kod tog poslodavca ili koji ima prekid između dva radna odnosa duži od osam dana, nema pravo na tzv. puni godišnji odmor, nego ima pravo na <strong>razmjerni godišnji odmor.</strong></p>
    <p><strong>Važno je naglasiti da u određenim situacijama, ukupno trajanje godišnjeg odmora pojedinih radnika može biti duže od punog godišnjeg odmora, a to prikazujemo u sljedećem primjeru:</strong></p>
    <p>radniku je kod prvog poslodavca radni odnos prestao u prvoj polovini godine te za navedeni radni odnos ostvaruje pravo na razmjerni dio godišnjeg odmora. Kod drugog poslodavca se zaposlio nakon prekida dužeg od 8 dana, ali radni odnos radnika je započeo prije 1. srpnja iste godine i trajao je više od šest mjeseci navedene godine čime stječe pravo na puni godišnji odmor kod drugog poslodavca.</p>
    <p><strong>Bitno je istaknuti značajnu pojmovnu razliku koja se odnosi na stjecanje prava na godišnji odmor i ​ostvarivanja prava na godišnji odmor (pojam stjecanja različit je od pojma ostvarivanja), a koja se može pojaviti kod prestanka radnog odnosa.</strong></p>
    <p>Naime, ukoliko radnik <strong>stekne pravo</strong> na tzv. puni godišnji odmor (navedeno pravo radniku se može potvrditi i odlukom o rasporedu korištenja godišnjeg odmora), no iz zakonom određenog razloga (istek ugovora o radu, otkaz, sporazum i sl.) radniku u toj kalendarskoj godini prestaje radni odnos, za tu kalendarsku godinu ipak <strong>ostvaruje pravo</strong> na razmjerni dio godišnjeg odmora, tj. stečeno pravo na puni godišnji odmor <strong>se "pretvara" u pravo na razmjerni dio godišnjeg odmora i ostvaruje isto u tom obliku.</strong></p>
    <p>Uslijed zakonskih odredbi koje reguliraju:</p>
    <p>- stjecanje prava <strong>puni</strong> godišnji odmor,</p>
    <p>- stjecanje prava na <strong>razmjerni</strong> godišnji odmor te</p>
    <p><strong>- ostvarivanje</strong>​ navedenih prava na godišnji odmor u slučaju prestanka radnog odnosa,</p>
    <p><strong>kod promjena dva ili više poslodavca tijekom godine može doći do sljedećih situacija koje prikazujemo kroz primjere u nastavku:</strong></p>
    <p><strong>Primjer 1.</strong></p>
    <p>Radnik je kod prvog poslodavca radio do 31. rujna i kod tog poslodavca je ostvario pravo na puni godišnji odmor.</p>
    <p>Kod drugog poslodavca se zaposlio od 1. listopada te je radio do kraja godine i taj mu je poslodavac dužan osigurati razmjerni godišnji odmor u trajanju od četiri dvanaestine punog godišnjeg odmora.</p>
    <p><strong>Primjer 2.</strong></p>
    <p>Radniku je kod prvog poslodavca radni odnos prestao s danom 28/29. veljače, a kod drugog poslodavca se zaposlio od 1. ožujka<strong> (nema prekida između radnih odnosa; u slučaju da je prekid duži od 8 dana ostvario bi nakon 6 mjeseci rada pravo na puni godišnji odmor​)</strong> i radio je do kraja godine. Kod prvog je poslodavca radnik stekao pravo na razmjerni dio godišnjeg odmora u trajanju od dvije dvanaestine, a kod drugog također pravo na razmjerni dio, u trajanju od deset dvanaestina, pri čemu mu je drugi poslodavac dužan omogućiti korištenje navedenog godišnjeg odmora u neprekidnom trajanju od dva tjedna, osim ako se radnik i poslodavac drugačije sporazume.</p>
    <p>Dakle, tek nakon što je poslodavac utvrdio na koliko je dana godišnjeg odmora radnik <strong>ostvario pravo</strong> (postoji razlika između stjecanja prava i ostvarivanja prava) i u kojem trajanju, poslodavac može valjano utvrditi odlukom kada će radnik <strong>koristiti</strong> ​godišnji odmor (navedenu odluku treba razlikovati od odluke o rasporedu korištenja godišnjeg odmora) u danima prema radnikovom tjednom rasporedu rada.</p>
    <p><strong>Osim specifičnosti vezanih uz stjecanje/ostvarivanje prava na godišnji odmor, pri korištenju godišnjeg odmora treba se pridržavati sljedećih zakonom određenih odredbi:</strong></p>
    <p>Blagdani i neradni dani određeni zakonom, razdoblje privremene nesposobnosti za rad koje je utvrdio ovlašteni liječnik te dani plaćenog dopusta, ne uračunavaju se u trajanje godišnjeg odmora, no ako bi radnik na svoj zahtjev koristio godišnji odmor na blagdan i neradni dan koji po njegovom rasporedu predstavlja radni dan, u trajanje godišnjeg odmora uračunava se i taj dan.</p>
    <p>Radniku koji radi u nepunom radnom vremenu kod dva ili kod više poslodavaca, a poslodavci ne postignu sporazum o istodobnom korištenju godišnjeg odmora, dužni su mu omogućiti korištenje godišnjeg odmora prema njegovu zahtjevu.</p>
    <p><strong>Ako radnik koristi godišnji odmor u dijelovima, mora tijekom kalendarske godine za koju ostvaruje pravo na godišnji odmor iskoristi najmanje dva tjedna u neprekidnom trajanju, osim ako se radnik i poslodavac drukčije ne dogovore, pod uvjetom da je ostvario pravo na godišnji odmor u trajanju dužem od dva tjedna.</strong></p>
    <p>Točnije rečeno, poslodavac mora radniku koji je ostvario pravo na puni godišnji odmor omogućiti najmanje dva tjedna od navedenog godišnjeg odmora u godini u kojoj je ostvario pravo na puni godišnji odmor.</p>
    <p>Neiskorišteni dio godišnjeg odmora u trajanju dužem od spomenutog dijela godišnjeg odmora od dva tjedna, radnik može prenijeti i iskoristiti najkasnije do 30. lipnja sljedeće kalendarske godine, no radnik ne može prenijeti i navedeni dio godišnjeg odmora spomenut u prethodnoj rečenici (dva tjedna).</p>
    <p>Ipak, godišnji odmor, odnosno dio godišnjeg odmora koji je prekinut ili nije korišten u kalendarskoj godini u kojoj je stečen, zbog bolesti te korištenja prava na rodiljni, roditeljski i posvojiteljski dopust te dopusta radi skrbi i njege djeteta s težim smetnjama u razvoju, radnik ima pravo iskoristiti po povratku na rad,<strong> a najkasnije do 30. lipnja sljedeće kalendarske godine.</strong></p>
    <p>Dodatno, ukoliko radnik nije mogao iskoristiti godišnji odmor zbog korištenja prava na rodiljni, roditeljski i posvojiteljski dopust te dopust radi skrbi i njege djeteta s težim smetnjama u razvoju (bolest radnika ne daje osnovu za takvo korištenje godišnjeg odmora) ili njegovo korištenje poslodavac nije omogućio, <strong>radnik ima pravo iskoristiti godišnji odmor do kraja kalendarske godine u kojoj se vratio na rad.</strong></p>
    <p><strong>Važno: Za vrijeme korištenja godišnjeg odmora teče otkazni rok. Točnije rečeno, otkazni rok se ne prekida uslijed korištenja godišnjeg odmora.</strong></p>
    <h5><strong>SVRHA DOKUMENTA</strong></h5>
    <p>Svrha dokumenta zakonito je ostvarivanje prava radnika na godišnji odmor, obavještavanje radnika o trajanju i korištenju godišnjeg odmora te valjano evidentiranje godišnjeg odmora za potrebe poslodavca kroz evidenciju radnog vremena i obračun plaće.</p>
    <h5><strong>NAJČEŠĆE GREŠKE</strong></h5>
    <p><strong>- Kašnjenje u obavještavanju radnika o trajanju i razdoblju korištenja godišnjeg odmora.</strong></p>
    <p>Pojašnjenje: sukladno Zakonu o radu, Poslodavac mora radnika najmanje petnaest dana prije korištenja godišnjeg odmora obavijestiti o trajanju godišnjeg odmora i razdoblju njegova korištenja.</p>
    <p><strong>- Poslodavac nije radniku omogućio korištenje punog ili razmjernog godišnjeg odmora</strong></p>
    <p>Pojašnjenje: poslodavac mora radniku omogućiti korištenje godišnjeg odmora (punog ili razmjernog), osim u slučaju prestanka radnog odnosa kada je poslodavac dužan radniku koji nije iskoristio godišnji odmor isplatiti naknadu umjesto korištenja godišnjeg odmora.</p>
    <p><strong>- Poslodavac nije radniku u godini u kojoj je ostvario pravo godišnji odmor u trajanju dužem od dva tjedna omogućio korištenje godišnjeg odmora u neprekidnom trajanju od dva tjedna, a radnik i poslodavac se nisu drugačije sporazumjeli ili ne postoje izuzeci (bolest, rodiljni ili roditeljski dopust i sl.)- prekršaj</strong></p>
    <p>Pojašnjenje: ako radnik koristi godišnji odmor u dijelovima, mora tijekom kalendarske godine za koju ostvaruje pravo na godišnji odmor iskoristi najmanje dva tjedna u neprekidnom trajanju, osim ako se radnik i poslodavac drukčije ne dogovore, pod uvjetom da je ostvario pravo na godišnji odmor u trajanju dužem od dva tjedna.</p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o radu,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
              suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: '​donosi sljedeću',
    title: 'ODLUKA O KORIŠTENJU ODMORA ZA ________ GODINU',
    noArticleNumbers: true,

    articles: [
        {
            mandatory: true,
            statements: [
                {
                    title: '',
                    type: 'choice',
                    mandatory: true,
                    choices: [
                        {
                            parts: [
                                {type: 'text', content: 'Radnik'},
                                { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                { type: "text", content: "," },
                { type: 'text', content: 'iz',},
                                { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                                { type: 'text', content: ',' },
                                { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                                { type: "text", content: "," },
                                { type: 'text', content: 'OIB:' },
                                {type: 'input', value: '', required: true},
                                {
                                    type: 'text',
                                    content: ', (u daljnjem tekstu: Radnik) ima sukladno Ugovoru o radu i sukladno čl. 77. Zakona o radu (puni godišnji odmor), pravo na godišnji odmor za'
                                },
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'kalendarsku godinu u trajanju od'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'dana.', help: 'Ukoliko odlukom regulirate pravo na PUNI godišnji odmor, onda  odabirate ovu opciju. Za točno utvrđivanje prava na godišnji odmor, molimo pročitajte tekst gore.'}
                            ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Radnik'},
                                { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                                { type: "text", content: "," },
                                { type: 'text', content: 'iz',},
                                { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                                { type: 'text', content: ',' },
                                { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                                { type: "text", content: "," },
                                { type: 'text', content: 'OIB:' },
                                {type: 'input', value: '', required: true},
                                {
                                    type: 'text',
                                    content: ', (u daljnjem tekstu: Radnik) ima sukladno Ugovoru o radu i sukladno čl. 78. Zakona o radu (razmjerni godišnji odmor), pravo na godišnji odmor za'
                                },
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'kalendarsku godinu u trajanju od'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'dana.', help: 'Ukoliko odlukom regulirate pravo na RAZMJERNI godišnji odmor, onda  odabirate ovu opciju. Za točno utvrđivanje prava na godišnji odmor, molimo pročitajte tekst gore.'}
                            ]
                        },
                    ],
                    value: '',
                },

            ],
        },
        {
            mandatory: true,
            editable: true,
            statements: [
                {
                    title: '',
                    type: 'choice',
                    mandatory: true,
                    choices: [
                        {
                            parts: [
                                {type: 'text', content: 'Radnik će cijeli godišnji odmor za'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'godinu u trajanju od'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'dana koristiti u razdoblju od'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'do'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'godine.', help: 'U ovoj opciji, radnik će koristiti stečeni godišnji odmor u cijelosti.'},
                            ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Radnik će dio godišnjeg odmora za'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'godinu u trajanju od'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'dana koristiti u razdoblju od'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'do'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'godine.', help: 'U ovoj opciji, radnik će koristiti stečeni godišnji odmor u dijelovima.'},
                            ]
                        },
                    ],
                    value: '',
                },
            ],
        },
        {
            title: '',
            mandatory: true,
            editable: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: false,
                    content: 'Za vrijeme trajanja godišnjeg odmora radnik ima pravo na naknadu plaće, najmanje u visini njegove prosječne mjesečne plaće u prethodna tri mjeseca (uračunavajući sva primanja u novcu i naravi koja predstavljaju naknadu za rad).',
                    value: '',
                }],
        },
        {
          title: '------------------------------------------------------Obrazloženje------------------------------------------------------',
          mandatory: true,
            dummy: true,
            statements:   [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Sukladno Ugovoru o radu i Zakonu o radu, Radniku pripada broj radnih dana godišnjeg odmora kako je utvrđeno u izreci.',
                    value: '',
                }],
        },
        { title: '',
        mandatory: false,
        dummy: true,
        editable: true,
        statements:
          [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {
                            type: 'text',
                            content: 'Shodno mogućnostima, te uzimajući u obzir potrebe organizacije rada, radnik će preostali dio godišnjeg odmora za'
                        },
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'godinu u trajanju od'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'dana koristiti u dogovoru s Poslodavcem.'}],
                }],
            value: '',
        },
        {
            title: '',
            mandatory: true,
            dummy: true,
            statements:   [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: false,
                    content: 'Slijedom iznesenog, donesena je ova Odluka.',
                    value: '',
                }],
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine.",
                    help: 'Radnik mora biti obaviješten o godišnjem odmoru (trajanje, početak) najmanje 15 dana prije početka korištenja.',
                  }
                ]
              },
            ]
          },
          {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
          },
          {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
              {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba',
                help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
              }
            ]
          },
          {
            static: true,
            mandatory: true,
            type: 4, 
            statements: [
              {
                type: 'text',
                mandatory: true,
                editable: true,
                help: 'Ako postupak dostave nije uređen kol. ug., sporazumom između radničkog vijeća i poslodavca ili pravilnikom o radu, primjenjuju se odredbe o dostavi određene parničnim postupkom. U tom slučaju, otkaz se može dostaviti prep. pošt. pošiljkom s povr. ili osobno, na radnom mjestu, no ukoliko radnik odbija primiti odluku, navedeno odbijanje može se pisano konstatirati uz potpis dva svjedoka. Otkaz se može dostaviti i putem j. bilježnika.',
                content: 'Potvrđujem primitak Odluke dana _______________ godine.\r\n\r\nPotpis Radnika: ____________________\r\n\r\n',
              },
            ]
          },
        ],
      };


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/30_odluka_o_koristenju_godisnjeg_odmora.ts